import { animate, createTimeline } from 'animejs';

const fadeIn = (text, button, onComplete) => {
  // Guard clause: Ensure refs are attached before animating
  if (!text.current || !button.current) return;

  createTimeline({
    defaults: {
      ease: 'outCubic',
    },
    onComplete: () => {
      onComplete?.();
    },
  })
    .add(
      button.current,
      {
        opacity: [0, 1],
        duration: 2800,
        translateY: [-30, 0],
      },
      1800,
    )
    .add(
      text.current,
      {
        opacity: [0, 1],
        duration: 2800,
        translateY: [-30, 0],
      },
      500,
    );
};

const fadeOut = (text, button, onComplete) => {
  if (!text.current || !button.current) return;

  animate(text.current, {
    ease: 'linear',
    translateY: [0, -10],
    opacity: [1, 0],
    duration: 500,
  });

  animate(button.current, {
    ease: 'linear',
    translateY: [0, -10],
    opacity: [1, 0],
    duration: 500,
    delay: 300,
    onComplete: () => {
      onComplete?.();
    },
  });
};

export { fadeIn, fadeOut };
